// extracted by mini-css-extract-plugin
export default {"otherInfo":"OtherInfo_otherInfo__maYQF","infoTitle":"OtherInfo_infoTitle__vyr8k"};